// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.admanagement.selfserveonboarding.RentalManagerUserSelfServiceOnboardingV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { SubmitManualListingV2RequestDto } from '../..';

export const RentalManagerUserSelfServiceOnboardingV2WebApiHandler_submitManualListing_Path =
  '/api/web/v2/users/adManagement/selfServeOnboarding/submitManualListing';

/**
 * Submit manual self serve onboarding listing for review
 */
export const RentalManagerUserSelfServiceOnboardingV2WebApiHandler_submitManualListing = (
  postData: SubmitManualListingV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SubmitManualListingV2RequestDto, void>(
    {
      endpoint: RentalManagerUserSelfServiceOnboardingV2WebApiHandler_submitManualListing_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
